import React, {useState} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {authApi} from '../../../api/api';
import {ApiError} from '../../../api/http';
import {useAuth} from '../../../app/providers/AuthProvider';
import { useTranslation } from 'react-i18next';

export function AdminLoginPage() {
    const { t } = useTranslation();
    const auth = useAuth();
    const navigate = useNavigate();
    const location = useLocation() as { state?: { from?: string } };

    const [nombreUsuario, setNombreUsuario] = useState('');
    const [password, setPassword] = useState('');
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const destino = location.state?.from ?? '/administracion';

    return (
        <div className="adminLoginPage">
            <div className="adminLoginCard">
                <div className="adminLoginHeader">
                    <div className="adminLoginEyebrow">{t('adminLoginPage.privateAccess')}</div>
                    <h1 className="adminLoginTitle">{t('adminLoginPage.login')}</h1>
                </div>


                <form
                    className="stack"
                    onSubmit={async (event) => {
                        event.preventDefault();
                        setCargando(true);
                        setError(null);

                        try {
                            const sesion = await authApi.login({nombreUsuario, password});
                            auth.setSesion(sesion);
                            navigate(destino, {replace: true});
                        } catch (err) {
                            setError(renderLoginError(err, t));
                        } finally {
                            setCargando(false);
                        }
                    }}
                >
                    <label className="label">
                        {t('adminLoginPage.username')}
                        <input
                            className="input"
                            value={nombreUsuario}
                            onChange={(e) => setNombreUsuario(e.target.value)}
                            placeholder={t('adminLoginPage.usernamePlaceholder')}
                            autoComplete="username"
                        />
                    </label>

                    <label className="label">
                        {t('adminLoginPage.password')}
                        <input
                            className="input"
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder={t('adminLoginPage.passwordPlaceholder')}
                            autoComplete="current-password"
                        />
                    </label>

                    {error ? (
                        <div className="alert alertError">
                            <strong>{t('adminLoginPage.accessError')}</strong>
                            <div className="muted">{error}</div>
                        </div>
                    ) : null}

                    <div className="formActions">
                        <Link className="btn btnSecondary" to="/">
                            {t('adminLoginPage.backToPublic')}
                        </Link>

                        {auth.isAuthenticated ? (
                            <button className="btn btnGhost" type="button" onClick={auth.logout}>
                                {t('adminLoginPage.logout')}
                            </button>
                        ) : null}

                        <button className="btn btnPrimary" type="submit" disabled={cargando}>
                            {cargando ? t('adminLoginPage.accessing') : t('adminLoginPage.enter')}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

function renderLoginError(error: unknown, t: (key: string) => string) {
    if (error instanceof ApiError) {
        if (error.status === 401) return t('adminLoginPage.invalidCredentials');
        if (error.status === 400) return t('adminLoginPage.validationError');
        if (error.status === 0) return t('adminLoginPage.connectionError');
        return `${error.status}: ${error.message}`;
    }

    if (error instanceof Error) return error.message;
    return t('adminLoginPage.unknownError');
}
